module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-left-a463892cc65a3198e8f3635e4523bd10.svg";